import React from 'react';
import { Grid, Box } from '@mui/material';
import { useRecoilValue, useRecoilState } from 'recoil';
import CostSummary from 'pages/provisioning/_components/CostSummary';
import ADGroupForm from 'pages/myidm/components/sections/ADGroupForm';
import { OrderPayload, toggleSspModels, costEstimateState } from 'pages/myidm/store';
import { SubmitRequest, CancelRequest } from 'pages/myidm/components';
import ADGroupMembers from 'pages/myidm/components/sections/ADGroupMembers';
import MultipleADGroupMembers from 'pages/myidm/components/sections/multiple/MultipleADGroupMembers';
import LdapGroupMembers from 'pages/myidm/components/sections/LdapGroupMembers';
import { AD_GROUP, LDAP_GROUP, REQUEST_TYPE, MODIFY_REQUEST_TYPE } from 'pages/myidm/utils/constant';

const SspForm = () => {
    const order = useRecoilValue(OrderPayload);
    const [modal, setModal] = useRecoilState(toggleSspModels);
    const [costEstimate] = useRecoilState(costEstimateState);
    // const isDisableGroupRequest = order?.typeOfRequest === REQUEST_TYPE.DISABLE_GROUP;
    const handleCostInfoBtn = (type) => {
        setModal({
            ...modal,
            isCost: { costType: type, isCostOpen: true },
        });
    };
    return (
        <Box paddingY={1} className="contentContainer">
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                        <ADGroupForm />
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <Grid container spacing={1} flexDirection="column">
                        {order?.estimatedCost?.details?.length > 0 && costEstimate?.details?.length > 0 && (
                            <Grid item xs={12}>
                                <Box sx={{ marginTop: `${order?.typeOfRequest === REQUEST_TYPE.NEW ? '19px' : '31px'}` }}>
                                    <CostSummary
                                        handleCostInfoBtn={handleCostInfoBtn}
                                        cartBtn={
                                            <Box sx={{ disaplay: 'flex', flexDirection: 'column' }} gap={1}>
                                                <SubmitRequest />
                                                <CancelRequest />
                                            </Box>
                                        }
                                        costEstimate={costEstimate}
                                    />
                                </Box>
                            </Grid>
                        )}
                        {order?.typeOfRequest === REQUEST_TYPE.MODIFY && order?.groupType === AD_GROUP && (
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        marginTop: `${
                                            (order?.estimatedCost?.details?.length > 0 && costEstimate?.details?.length > 0) ||
                                            order?.typeOfRequest === REQUEST_TYPE.MODIFY
                                                ? '15px'
                                                : '32px'
                                        }`,
                                    }}
                                >
                                    <MultipleADGroupMembers multipleAdGroups={order?.multipleAdGroups || []} order={order} />
                                </Box>
                            </Grid>
                        )}
                        {/*    {isDisableGroupRequest && (
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        marginTop: '15px',
                                    }}
                                >
                                    <MultipleADGroupMembers multipleAdGroups={order?.adGroupListForDisable || []} />
                                </Box>
                            </Grid>
                        )} */}
                        {order?.adGroup && (
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        marginTop: `${
                                            (order?.estimatedCost?.details?.length > 0 && costEstimate?.details?.length > 0) ||
                                            order?.typeOfRequest === REQUEST_TYPE.MODIFY
                                                ? '15px'
                                                : '32px'
                                        }`,
                                    }}
                                >
                                    {order?.groupType === AD_GROUP && order?.modifyRequestType !== MODIFY_REQUEST_TYPE.REMOVAL && <ADGroupMembers />}
                                    {order?.groupType === LDAP_GROUP && <LdapGroupMembers />}
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SspForm;
